import { render } from "./UpdateVouchers.vue?vue&type=template&id=d79d9cf4"
import script from "./UpdateVouchers.vue?vue&type=script&lang=js"
export * from "./UpdateVouchers.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Proyectos\\ERP ELECTRONICO\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__